/* eslint-disable @typescript-eslint/no-explicit-any */

import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import reduxThunk from 'redux-thunk';
import { USED_AS_SPA } from './config';
import aiCoachContentReducer from './reducers/aiCoachContentReducer';
import courseReducer from './reducers/courseReducer';
import exerciseEntities from './reducers/exerciseEntities';
import settingsReducer from './reducers/settingsReducer';
import transcriptReducer from './reducers/transcriptReducer';
const rootReducer = combineReducers({
  aiCoachContent: aiCoachContentReducer,
  course: courseReducer,
  exerciseEntities,
  globalSettings: settingsReducer,
  transcript: transcriptReducer
});
function isDefinedObject(obj) {
  return typeof obj === 'object';
}
function hasExt(obj) {
  return !!obj;
}
const win = global;
const composeEnhancers = USED_AS_SPA && isDefinedObject(win) && hasExt(win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? win.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(reduxThunk)));
export default store;